if (!customElements.get('order-flow-tabs')) {
  class OrderFlowTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.getAttribute('aria-controls')));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });

      // カスタマイザーでブロック選択時、そのブロックを含むタブへ切り替える
      this.addEventListener('shopify:block:select', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) {
          this.select(tab.getAttribute('aria-controls'));
          return;
        }
        const panel = event.target.closest('[role="tabpanel"]');
        if (panel) this.select(panel.id);
      });
    }

    onKeydown(event, tab) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const index = this.tabs.indexOf(tab);
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const next = this.tabs[(index + offset + this.tabs.length) % this.tabs.length];
      next.focus();
      this.select(next.getAttribute('aria-controls'));
    }

    select(panelId) {
      this.panels.forEach((panel) => panel.toggleAttribute('hidden', panel.id !== panelId));
      this.tabs.forEach((t) => {
        t.setAttribute('aria-selected', t.getAttribute('aria-controls') === panelId ? 'true' : 'false');
      });
    }
  }
  customElements.define('order-flow-tabs', OrderFlowTabs);
}
